/* import __COLOCATED_TEMPLATE__ from './card-invitation-management.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { ResendToastStatus } from '@banking/ui/workflows/card-invitation-management';

/**
 * NOTE(cvu): There are a few states in this presentation component and to make it easier for
 * myself, I am going to categorize them. This state will be dictated by whatever functionality.
 */
export let InvitationManagementState = /*#__PURE__*/function (InvitationManagementState) {
  InvitationManagementState["Loading"] = "LOADING";
  InvitationManagementState["ActiveInvitation"] = "ACTIVE_INVITATION";
  InvitationManagementState["CanceledInvitation"] = "CANCELED_INVITATION";
  InvitationManagementState["Error"] = "ERROR";
  return InvitationManagementState;
}({});
let CardInvitationManagement = (_class = class CardInvitationManagement extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "InvitationManagementState", InvitationManagementState);
    _initializerDefineProperty(this, "cardPreview", _descriptor, this);
    _initializerDefineProperty(this, "infoText", _descriptor2, this);
    _initializerDefineProperty(this, "hasActiveInvitation", _descriptor3, this);
    _defineProperty(this, "ResendToastStatus", ResendToastStatus);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cardPreview", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      businessName: this.args.businessName,
      cardholder: '',
      customizationImageDataURL: '',
      cvc: '',
      expirationDate: '',
      fullPan: ''
    };
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "infoText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hasActiveInvitation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export { CardInvitationManagement as default };